import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';
import _ from 'lodash';
import { Link } from 'react-router';

// Services
import Ticket from 'services/data/ticket';
import Team from 'services/data/team';

// Components
import SVG from 'components/widgets/icons/svg';
import CopyToClipboard from 'components/widgets/icons/copy-to-clipboard';

// Utils
import { stopPropagation, preventDefault } from 'utils/event-handlers';

// Constants
import { CC_DOMAIN } from 'constants';


export default class TicketOptions extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    addTask: PropTypes.func,
    addTimeReport: PropTypes.func.isRequired,
    addFolder: PropTypes.func.isRequired,
    ticket: PropTypes.object.isRequired,
    editTicket: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    teams: PropTypes.array.isRequired
  };

  constructor() {
    super();

    this.state = { showPopover: false };

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  show() {
    this.setState({ showPopover: !this.state.showPopover });
  }

  hide() {
    this.setState({ showPopover: false });
  }

  render() {
    const { children, addTask, addTimeReport, addFolder, ticket, currentUser, teams, editTicket } = this.props;
    const { showPopover } = this.state;

    const hasAgreement = ticket.agreement && !_.isEmpty(ticket.agreement);

    const ticketCC = Ticket.getTicketCC(ticket);
    const ticketMailToLink = Ticket.getMailtoLink(ticket, ticketCC);
    const ticketTeamCC = `${Ticket.getTicketCC(ticket)},${Ticket.getTeamEmails(ticket, currentUser, teams)}`;
    const ticketTeamMailToLink = Ticket.getMailtoLink(ticket, ticketTeamCC);
    const myTeamCC = `${Ticket.getTicketCC(ticket)},${Team.getTeamEmails(currentUser, teams)}`;
    const myTeamMailToLink = Ticket.getMailtoLink(ticket, myTeamCC);
    const team = Ticket.getTeam(ticket, teams);

    return (
      <div onClick={preventDefault(this.show)} className="ticket-options-wrapper">
        {children}
        <Overlay
          rootClose
          show={showPopover}
          placement="bottom"
          target={this}
          onHide={this.hide}
        >
          <Popover
            id="ticket-options-window"
            className="clickable-options-list"
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            <ul className="unstyled-list" onClick={this.hide}>
              {editTicket &&
                <li onClick={editTicket}>
                  <SVG src="svg/edit.svg" className="edit" />
                  Edit Ticket
                </li>
              }
              {addTask &&
                <li onClick={addTask}>
                  <SVG src="svg/check.svg" className="task-checkbox" />
                  Add Task
                </li>
              }
              {hasAgreement &&
                <li onClick={addTimeReport}>
                  <SVG src="svg/time-report.svg" className="time-report" />
                  Add Time Report
                </li>
              }
              {hasAgreement &&
                <li>
                  <Link to={`/purchases/add?ticket=${ticket.id}`} className="unadorned flex grow">
                    <SVG src="svg/expense-bill.svg" className="expense-bill" />
                    <div className="grow">
                      Add Purchase Order
                      <div className="deemphasize">PO#: {currentUser.poPrefix}-{ticket.id}</div>
                    </div>
                  </Link>
                  <CopyToClipboard component="span" copyText={`${currentUser.poPrefix}-${ticket.id}`} tooltip="Copy the PO number for this ticket">
                    <SVG src="svg/clipboard.svg" className="clipboard" />
                  </CopyToClipboard>
                </li>
              }
              <li>
                <a href={ticketMailToLink} target="_blank" className="unadorned flex grow">
                  <SVG src="svg/email.svg" className="email" />
                  <div className="grow">
                    Email Ticket
                    <div className="deemphasize">ticket-{ticket.id}@{CC_DOMAIN}</div>
                  </div>
                </a>
                <CopyToClipboard component="span" copyText={ticketCC} tooltip="Copy the ticket CC only">
                  <SVG src="svg/clipboard.svg" className="clipboard" />
                </CopyToClipboard>
              </li>
              {team &&
                <li>
                  <a href={ticketTeamMailToLink} target="_blank" className="unadorned flex grow">
                    <SVG src="svg/email.svg" className="email" />
                    <div className="grow">
                      Email Ticket Team
                      <div className="deemphasize">ticket-{ticket.id}@{CC_DOMAIN} & {team.name}</div>
                    </div>
                  </a>
                  <CopyToClipboard component="span" copyText={ticketTeamCC} tooltip="Copy the ticket CC and ticket team members' emails">
                    <SVG src="svg/clipboard.svg" className="clipboard" />
                  </CopyToClipboard>
                </li>
              }
              <li>
                <a href={myTeamMailToLink} target="_blank" className="unadorned flex grow">
                  <SVG src="svg/email.svg" className="email" />
                  <div className="grow">
                    Email My Team
                    <div className="deemphasize">ticket-{ticket.id}@{CC_DOMAIN} & {currentUser.team.name}</div>
                  </div>
                </a>
                <CopyToClipboard component="span" copyText={myTeamCC} tooltip="Copy the ticket CC and your team members' emails">
                  <SVG src="svg/clipboard.svg" className="clipboard" />
                </CopyToClipboard>
              </li>
              {_.isEmpty(ticket.folder) &&
                <li onClick={addFolder}>
                  <SVG src="svg/google-drive.svg" className="google-drive" />
                  Create Ticket Folder
                </li>
              }
            </ul>
          </Popover>
        </Overlay>
      </div>
    );
  }
}
